export const API: any = {
  DEV: () => 'https://api-sbx.nominasaps.com/api/v2/',
  STAGGING: () => 'https://api-sbx.nominasaps.com/api/v2s/',
  PROD: () => 'https://api-next.nominasaps.com/api/v2/',
  PREVIEW: () => {
    // get the pr number from the url
    const prName = window.location.hostname.split('.')[0]
    return `https://api-preview.nominasaps.com/${prName}/api/v2/`
  },
  PREVIEW_NEW: () => {
    return `https://api-preview.nominasaps.com/preview/api/v2/`
  }
}

export const API_NEW: any = {
  DEV: () => 'https://a6mnlwgjnj.execute-api.us-east-1.amazonaws.com/public/',
  STAGGING: () =>
    'https://a6mnlwgjnj.execute-api.us-east-1.amazonaws.com/public/',
  PROD: () => 'https://dbbgzmjy47.execute-api.us-east-1.amazonaws.com/public/',
  PREVIEW: () =>
    'https://a6mnlwgjnj.execute-api.us-east-1.amazonaws.com/public/',
  PREVIEW_NEW: () =>
    'https://a6mnlwgjnj.execute-api.us-east-1.amazonaws.com/public/'
}

export const SET_WORKSPACE_PERMISSION = 'user:set_workspace'
export const VERSION = () => import.meta.env.VITE_VERSION || 'v2.431.3-main(fd5e305)'
export const ENV = () => {
  const env = () => import.meta.env.VITE_ENV || 'PROD' // DEV PROD STAGGING PREVIEW
  return env().includes('ENV') ? 'DEV' : env()
}
